import { addStyles } from '../../../components/theme';
import { m, type MithrilVNode } from '../../../mithril';

const CSS = {
	line: 'c-GenericMapLine',
};

const Style = {
	[CSS.line]: {
		position: 'absolute',
		strokeWidth: '2px',
		fill: 'none',
		pointerEvents: 'none',
	},
};

addStyles(Style);

export interface GenericMapLineOptions {
	key: string;
	start: google.maps.Point;
	end: google.maps.Point;
	color: string;
	strokeWidth?: string;
	onClick?: () => void;
	additionalClasses?: string;
	additionalStyles?: Record<string, any>;
}

export const GenericMapLine = {
	view({
		key,
		start,
		end,
		color,
		strokeWidth = '2px',
		onClick,
		additionalClasses,
		additionalStyles,
	}: GenericMapLineOptions): MithrilVNode {
		// Pad the SVG by the stroke width so lines along an axis (0px width or height) remain visible
		const pad = parseFloat(strokeWidth) || 2;
		const minX = Math.min(start.x, end.x) - pad;
		const minY = Math.min(start.y, end.y) - pad;
		const width = Math.abs(end.x - start.x) + pad * 2;
		const height = Math.abs(end.y - start.y) + pad * 2;

		return m(
			'svg',
			{
				key,
				className: CSS.line,
				style: {
					left: `${minX}px`,
					top: `${minY}px`,
					width: `${width}px`,
					height: `${height}px`,
					...additionalStyles,
				},
			},
			[
				m('line', {
					x1: start.x - minX,
					y1: start.y - minY,
					x2: end.x - minX,
					y2: end.y - minY,
					stroke: color,
					'stroke-width': strokeWidth,
					onclick: onClick,
					style: {
						pointerEvents: onClick ? 'auto' : 'none',
						cursor: onClick ? 'pointer' : 'default',
					},
				}),
			]
		);
	},
};
